import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { createStudentRemovalRequestFormData } from '../api';
import { StudentsRemovalRequestCreateFormResponse } from '../types/students';

export interface StudentsRemovalRequestCreateLoaderProps {
  studyPlanEnrollmentId: number;
  children: (data: {
    data: StudentsRemovalRequestCreateFormResponse;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  StudentsRemovalRequestCreateFormResponse,
  AxiosResultDefaultError
>();

export function useStudentsRemovalRequestCreateLoader() {
  return useFetch();
}

export function StudentsRemovalRequestCreateLoader({
  studyPlanEnrollmentId,
  children,
}: StudentsRemovalRequestCreateLoaderProps) {
  const request = useCallback(() => {
    return createStudentRemovalRequestFormData(studyPlanEnrollmentId);
  }, [studyPlanEnrollmentId]);
  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, error, loading, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
